import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/inspectPlan/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/inspectPlan/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/inspectPlan/remove', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/inspectPlan/save', params, options);

export const update = (params, options) => request.post('/api/inspectPlan/update', params, options);

export const getInspectProject = (ids) => {
  return request({
    url: '/api/inspectNode/getInspectProject',
    method: 'get',
    params: {
      ids,
    },
  });
};
export const getBasePropertyTree = (ids) => {
  return request({
    url: 'api/base/property/treeChildrenPowerNode',
    method: 'get',
    params: {
      ids,
    },
  });
};
